// John Eldhose 20201012
import React, { Component } from 'react';
import { Grid, IconButton, TextField, Typography } from '@material-ui/core';
import { Search, WebAsset } from '@material-ui/icons';

class ReconfigSearch extends Component {

  handleKeyPress = (e) => {
    if(e.key === 'Enter') {
      this.props.handleSearch();
      e.preventDefault();
    }
    else if(!(
      e.charCode === 45 ||
      (e.charCode > 47 && e.charCode < 58) ||
      (e.charCode > 64 && e.charCode < 91) ||
      (e.charCode > 96 && e.charCode < 123)
    ))
      e.preventDefault();
  }
  handleChange = (e) => {
    this.props.handleChange(e.target.value.toUpperCase())
  }

  render() {
    return (
      <div>
        <Typography variant='display1'>
          <center><font color='#385687'>
            Upgrade Product & Reconfigure Modules
          </font></center>
        </Typography>
        <p />
        <Grid container>
          <Grid item xs={12} sm={12} md={2} lg={2} xl={2} />
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
            <TextField
              style={{ border: '1px solid silver', borderRadius: '5px', boxShadow: '1px 1px 1px 1px #888888' }}
              fullWidth
              autoFocus={true}
              placeholder='Serial Number'
              value={this.props.sn}
              onKeyPress={this.handleKeyPress}
              onChange={this.handleChange}
              InputProps={{
                disableUnderline: true,
                startAdornment: (
                  <div style={{ backgroundColor: '#ecf0f1', padding: '10px 10px 0px 10px', borderRadius: '5px 0px 0px 5px', margin: '0px 10px 0px 0px' }}>
                    <WebAsset />
                  </div>
                ),
                endAdornment: (
                  <div style={{ backgroundColor: '#ecf0f1', borderRadius: '0px 5px 5px 0px' }}>
                    <IconButton onClick={() => this.props.handleSearch()}>
                      <Search color='primary' />
                    </IconButton>
                  </div>
                )
              }}
            />
            <Typography variant='caption'>
              To upgrade & change modules, please enter a valid serial number above and hit the Search button
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2} xl={2} />
        </Grid>
        <p />
      </div>
    );
  }
}

export default ReconfigSearch;



// WEBPACK FOOTER //
// ./src/components/lib/ReconfigSearch.js